<template>
    <div class="c-cartItems">
        <div
            class="c-cartItems__item"
            :class="{ 'c-cartItems__item--small': small }"
            v-for="lineItem in cart.lineItems"
            :key="lineItem.id"
        >
            <a :href="lineItem.url" class="image"
                ><img :src="lineItem.image" :alt="lineItem.title"
            /></a>
            <div class="data">
                <div>
                    <a :href="lineItem.url" class="heading">{{
                        lineItem.title
                    }}</a>
                    <div class="props">
                        <span v-if="lineItem.material">{{
                            lineItem.material
                        }}</span>
                        <span v-if="lineItem.material && lineItem.size">
                            /
                        </span>
                        <span v-if="lineItem.size">{{ lineItem.size }}</span>
                    </div>
                    <div class="options" v-if="lineItem.options">
                        <div
                            class="option"
                            v-for="(option, key) in lineItem.options"
                            :key="key"
                        >
                            <span>{{ key }}</span> {{ option }}
                        </div>
                    </div>
                    <div class="qty" v-if="showQty">
                        {{ lineItem.qty }} stk.
                    </div>
                </div>
                <div
                    class="actions"
                    :class="{
                        'actions--loading': isLoading(lineItem.id),
                    }"
                >
                    <div class="actions__holder" v-if="showSpinner">
                        <spinner
                            :min="1"
                            :value="lineItem.qty / lineItem.colliSize"
                            :step="1"
                            @input="
                                updateCart(
                                    lineItem.id,
                                    lineItem.colliSize,
                                    $event
                                )
                            "
                        ></spinner>
                        <inline-loader></inline-loader>
                    </div>
                    <div class="price">{{ lineItem.subTotal }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

import Spinner from './Spinner.vue'
import InlineLoader from './InlineLoader.vue'

export default {
    name: 'CartItems',
    components: {
        Spinner,
        InlineLoader,
    },
    data: () => {
        return {
            isUpdatingCart: false,
            itemsUpdating: [],
        }
    },
    computed: {
        ...mapState({
            cart: (state) => state.cart.cart,
            csrfToken: (state) => state.app.csrfToken,
        }),
    },
    props: {
        showSpinner: {
            type: Boolean,
            default: true,
        },
        showQty: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        isLoading(id) {
            return this.itemsUpdating.includes(id)
        },
        updateCart(lineItemId, colliSize, val) {
            this.itemsUpdating.push(lineItemId)
            const formData = new FormData()
            formData.append('action', 'quantity-extensions/cart/update-cart')
            formData.append('CRAFT_CSRF_TOKEN', this.csrfToken)

            formData.append(
                'lineItems[' + lineItemId + '][qty]',
                val * colliSize
            )

            this.sendRequest(formData).then(() => {
                this.itemsUpdating = this.itemsUpdating.filter(
                    (item) => item !== lineItemId
                )
            })
        },
        sendRequest(formData) {
            return axios
                .post(document.location.href, formData)
                .then((response) => {
                    if (response.data.success) {
                        this.$store.dispatch(
                            'cart/updateCart',
                            response.data.cart
                        )

                        this.getLineItem()
                    } else {
                        //Handle errors when adding to cart
                        this.shwoError = true

                        setTimeout(function () {
                            this.shwoError = false
                        }, 2000)
                    }

                    // this.addingToCart = false
                })
                .catch((error) => {})
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-cartItems {
    .c-slideInOverlay__inner {
        max-width: 400px;
    }

    &__item {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid $c-light-grey;

        .image {
            line-height: 0;
            margin-right: 14px;
            min-width: 95px;
        }

        .data {
            width: 100%;
        }

        .heading {
            color: $c-black;
            font-family: $font-heading;
            font-size: 20px;
            letter-spacing: -0.15px;
            line-height: 20px;
            text-transform: uppercase;
        }
        .qty {
            font-size: 11px;
            font-weight: 700;
            letter-spacing: -0.08px;
            line-height: 13px;
            text-transform: uppercase;
        }

        .props {
            margin-top: 2px;
            margin-bottom: 3px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: -0.08px;
            line-height: 13px;
            text-transform: uppercase;
        }

        .options {
            margin-bottom: 8px;
        }

        .option {
            font-size: 11px;
            letter-spacing: -0.08px;
            line-height: 13px;
            span {
                text-transform: uppercase;
                font-weight: 700;
            }
        }

        .actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 18px;

            &__holder {
                position: relative;
                overflow: hidden;
            }

            .o-loaderInline {
                display: none;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                margin-left: -22px;
                z-index: 3;

                div {
                    background: $c-white;
                }
            }

            &--loading {
                .actions__holder {
                    &::before {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        display: block;
                        content: '';
                        background: $c-black;
                        border: 2px solid $c-black;
                        z-index: 2;
                        border-radius: 25px;
                    }
                }

                .o-loaderInline {
                    display: inline-block;
                }
            }
        }

        .price {
            font-family: $font-heading;
            font-size: 19px;
            letter-spacing: -0.15px;
            line-height: 20px;
            text-align: right;
        }

        &--small {
            .image {
                width: 52px;
                min-width: 52px;
            }

            .data {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
            }

            .actions {
                margin-top: 0;
            }
        }
    }

    &__buttons {
        padding-top: 23px;
        .o-btn {
            margin-bottom: 5px;
        }
    }
}

@media all and (max-width: 413px) {
    .c-cartItems {
        &__item {
            flex-direction: column;
            align-items: center;

            .image {
                margin-right: 0;
                margin-bottom: 14px;
            }

            .data {
                text-align: center;
            }

            .actions {
                flex-direction: column-reverse;
                .price {
                    margin-bottom: 8px;
                }
            }
        }
    }
}
</style>
